// src/store/index.js
import { createStore } from 'vuex';

export default createStore({
  state: {
    userRoles: []
  },
  getters: {
    userRoles: state => state.userRoles
  },
  mutations: {
    setUserRoles(state, roles) {
      state.userRoles = roles || []; // 容错：避免设置 null/undefined
    },
    clearUserRoles(state) {
      state.userRoles = [];
    }
  },
  actions: {
    // 初始化角色（页面刷新时调用，从 localStorage 读取）
    initUserRoles({ commit }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        if (userInfo.role) {
          commit('setUserRoles', [userInfo.role]);
          console.log('Vuex 角色初始化:', [userInfo.role]);
        }
      } catch (e) {
        console.error('Vuex 角色初始化失败:', e);
        commit('setUserRoles', []);
      }
    }
  }
});